import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/constants';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var AssignProfilesToPortfolioAction = function () {

}


AssignProfilesToPortfolioAction.prototype = {

	assignProfilesToPortfolio: function (data) {

		restClient.assignProfilesToPortfolio(data, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else{
					AppDispatcher.dispatch({
						actionType: Constant.ASSIGN_PROFILES_TO_PORTFOLIO,
						data: error
					});
				}
			} else {
				response['status']= 200;
				AppDispatcher.dispatch({
					actionType: Constant.ASSIGN_PROFILES_TO_PORTFOLIO,
					data: response
				});
			}
		})
	}
}

export default new AssignProfilesToPortfolioAction();